export default class Loader {

	/**
	* Loads a new page by loading :
	*   - Images
	* TODO: - Load the view on first load of the site, not just on page change
	*
	* @param {Node} view - The DOM Element which is the view you want to load
	*
	* @returns {Promise} - Resolved when all components are loaded
	*/
	static load(view) {
		return new Promise((resolve) => {
			const images = Loader.getImages(view)
			// const videos = Loader.getVideos(view)
			const promises = []

			if (images && images.length) promises.push(Loader.loadImages(images))
			// if (videos && videos.length) promises.push(Loader.loadVideos(videos))

			Promise.all(promises)
			.then(resolve)
		})
	}

	static getImages(view) {
		const imgs = view.querySelectorAll('img')
		const urls = []
		const images = []

		for (let i = 0; i < imgs.length; i++) {
			let already = false

			for (let j = 0; j < urls.length; j++) {
				if (urls[j] === imgs[i].src) already = true
			}

			if (!already) {
				urls.push(imgs[i].src)
				images.push(imgs[i])
			}
		}

		return images
	}

	static getVideos(view) {
		const vids = view.querySelectorAll('video')
		const urls = []
		const videos = []

		for (let i = 0; i < vids.length; i++) {
			let already = false

			for (let j = 0; j < urls.length; j++) {
				if (urls[j] === vids[i].firstElementChild.src) already = true
			}

			if (!already) {
				urls.push(vids[i].firstElementChild.src)
				videos.push(vids[i])
			}
		}

		return videos
	}

  /**
    * Loads an array of images or string urls
    *
    * @param {Array} images - An array of Nodes `img` or String urls
    *
    * @returns {Promise} - Resolved when all images are loaded
    */
	static loadImages(images) {
		return new Promise((resolve) => {
			const promises = []

			for (let i = 0; i < images.length; i++) {
				promises.push(Loader.loadImage(images[i], images.length))
			}

			Promise.all(promises)
				.then(resolve)
		})
	}

  /**
    * Loads an image
    * TODO: - Check `data-src` instead of `src`
    *
    * @param {Node/String} image - The Node img of the image to load
    * @param {Node/Number} total - The number of images to load in total
    *
    * @returns {Promise} - Resolve when the image is loaded
    */
	static loadImage(image, total) {
		return new Promise((resolve) => {
			const src = image.getAttribute('src')

			if (!src || src === '') resolve()

			const img = new Image()

			if (img.complete) {
				if (Loader.cb) Loader.cb(total)
				resolve()
			} else {
				img.onload = () => {
					if (Loader.cb) Loader.cb(total)
					resolve()
				}
			}

			img.src = src
		})
	}

	/**
    * Loads an array of videos
    *
    * @param {Array} videos - An array of Nodes `video`
    *
    * @returns {Promise} - Resolved when all videos are loaded
    */
	static loadVideos(videos) {
		return new Promise((resolve) => {
			const promises = []

			for (let i = 0; i < videos.length; i++) {
				promises.push(Loader.loadVideo(videos[i]))
			}

			Promise.all(promises)
				.then(resolve)
		})
	}

	/**
    * Loads a video
    *
    * @param {Node/String} video - The Node video to load
    *
    * @returns {Promise} - Resolve when the video is loaded
    */
	static loadVideo(video) {
		return new Promise((resolve) => {
			let firstEvent = false

			video.oncanplay = () => {
				if (!firstEvent) {
					firstEvent = true

					resolve()
				}
			}
		})
	}

	static setCallback(fn = () => { }) {
		Loader.cb = fn
	}
}



// WEBPACK FOOTER //
// ./scripts/util/Loader.js